import { OENDisplayState } from "../enums/oe-display-state.enum";

export const ACTION_BTN_TO_DISPLAY_MAPPING = new Map<OENDisplayState, Array<string>>([
  [OENDisplayState.SHOW_ORDER_ENTRY, ["modifyAbort", "clear", "save", "submit"]],
  [OENDisplayState.SHOW_PROCESSING, ["duplicate", "submit"]],
  [OENDisplayState.SHOW_SUCCESS, ["copy", "new", "close"]],
  [OENDisplayState.SHOW_MONITOR_EXECUTION, ["duplicate", "close"]],
  [OENDisplayState.SHOW_REJECTED, ["duplicate", "edit", "close"]],
  [OENDisplayState.SHOW_APPROVAL_ALLOWED, ["duplicate", "diAbort", "diReject", "diApprove"]],
  [OENDisplayState.SHOW_APPROVAL_INTERNAL, ["duplicate", "diAbort"]],
  [OENDisplayState.SHOW_APPROVAL_EXTERNAL, ["duplicate", "diAbort"]],
  [OENDisplayState.SHOW_APPROVAL_EXTERNAL_MODIFY, ["duplicate", "modReject", "modAccept"]],
  [OENDisplayState.SHOW_MODIFY_OUT_ACCEPTANCE, ["duplicate", "modAbort", "modReject", "modAccept"]],
  [OENDisplayState.SHOW_ACCEPTANCE_ALLOWED, ["duplicate", "trAbort", "trReject", "trAccept"]],
  [
    OENDisplayState.SHOW_ACCEPTANCE_CALL,
    ["duplicate", "trAbort", "trReject", "trAcceptTop", "trAcceptDown"],
  ],
  [OENDisplayState.SHOW_ACCEPTANCE_EXTERNAL, ["duplicate", "trReject", "trAccept"]],
  [OENDisplayState.SHOW_ABORTING, []],
  [OENDisplayState.SHOW_TOLERANCE, ["edit", "toleranceAccept"]],
  [OENDisplayState.SHOW_UNLOCKED, ["duplicate", "edit", "close"]],
  [OENDisplayState.SHOW_AMEND_MARKUP, ["amCancel", "amReject", "amApprove"]],
  [OENDisplayState.SHOW_EXPIRY_PENDING, ["copy", "new", "close"]],
  [OENDisplayState.SHOW_LOST_HIDDEN, ["close"]],
]);

export const ACTION_ENTRY_DISPLAY_STATES = [
  OENDisplayState.SHOW_ORDER_ENTRY,
  OENDisplayState.SHOW_MODIFY_OUT_ACCEPTANCE,
  OENDisplayState.SHOW_AMEND_MARKUP,
];
